import { Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import { traitList } from "../../configs/config";
import { Row } from "../../styles/Utils";

interface TraitInputProps {
  selectedTraits: string[];
  setSelectedTraits: Dispatch<SetStateAction<string[]>>;
}

export default function TraitInput({ selectedTraits, setSelectedTraits }: TraitInputProps) {
  const handleTraitClick = (trait: string) => {
    setSelectedTraits((prev) =>
      prev.includes(trait) ? prev.filter((t) => t !== trait) : prev.length < 3 ? [...prev, trait] : prev
    );
  };

  return (
    <Row $gap={0.3} $justifyContent="space-evenly" $alignItem="center" $flexWrap="wrap">
      {traitList.map((e) => (
        <Chip key={e} $selected={selectedTraits.includes(e)} onClick={() => handleTraitClick(e)}>
          {e}
        </Chip>
      ))}
    </Row>
  );
}

const Chip = styled.div<{
  $selected: boolean;
}>`
  padding-inline: 1rem;
  padding-block: ${(props) => (props.$selected ? "1.5rem" : "1rem")};
  font-family: ${(props) => props.theme.font.family.main};
  background-color: ${(props) => (props.$selected ? props.theme.color.tertiary : props.theme.color.primary)};
  color: ${(props) => props.theme.color.tertiaryLight};
  border-radius: 100px;
  font-size: ${(props) => (props.$selected ? props.theme.font.size.title.medium : props.theme.font.size.title.small)};
`;
